import React, { memo, useContext, useState } from "react";
import { ScrollView, TouchableOpacity, Text, StyleSheet, View, Image } from "react-native";
import { getAvailableScreens } from "../../Login/Auth";
import { FONT_FAMILY, THEME_COLORS } from "../../../common/themes";
import { PurchaserContext, PurchaserInterface } from "@src/context/PurchaserContext";

const HeaderTab = (props) => {
  const { onPress, isActive, text, bottomText, img } = props;
  const IconComponent = props.icon;

  return (
    <TouchableOpacity
      style={[headerStyles.tab, { backgroundColor: isActive ? THEME_COLORS.sideMenuBgV3 : "#F7F2FA" }]}
      onPress={onPress}
    >
      {IconComponent && <IconComponent style={{ color: isActive ? THEME_COLORS.purple : THEME_COLORS.sideMenuGrey }} />}
      {img && (
        <Image
          source={img}
          style={{
            width: 22,
            height: 22,
            marginBottom: 12,
            tintColor: isActive ? THEME_COLORS.purple : THEME_COLORS.sideMenuGrey,
          }}
          resizeMode="contain"
        />
      )}
      <Text
        style={{
          ...headerStyles.tabText,
          fontFamily: FONT_FAMILY.primaryV3,
          textAlign: "center",
          fontSize: 11,
          color: isActive ? THEME_COLORS.purple : THEME_COLORS.sideMenuGrey,
        }}
      >
        {bottomText ?? text}
      </Text>
    </TouchableOpacity>
  );
};

const SideMenuV3 = ({ navigation, userMetaData, isUserLoggedIn, nonSidemenuScreens, onMouseEnter }) => {
  const { setMiscModal } = useContext<PurchaserInterface>(PurchaserContext);

  const screens = !!userMetaData
    ? getAvailableScreens(userMetaData).filter((val) => !nonSidemenuScreens.includes(val.screen))
    : [];
  const navState = navigation.state;
  const isNewFlow = localStorage.getItem("user_flow") === "NewFlow";

  const sparesExtraScreens = [
    "Purchase",
    "InventoryReplenishment",
    "InvenRepPurchaseRequest",
    "ReceivePartsVendor",
    "ReceivePartsTO",
    "ByCarV2",
  ];

  if (isUserLoggedIn)
    return (
      <View
        style={[
          headerStyles.sideMenu,
          {
            backgroundColor: "#F7F2FA",
          },
        ]}
        onMouseEnter={onMouseEnter}
      >
        <>
          <View style={{ alignItems: "center", marginTop: 20, marginBottom: 38 }}>
            <TouchableOpacity
              style={headerStyles.logo}
              onPress={() => {
                if (navState.routeName == "Main") return;
                navigation.navigate("Main");
              }}
            >
              <Image
                source={require("../../../assets/dashboard_icon.png")}
                style={{ width: 44, height: 44, marginTop: 8 }}
              />
            </TouchableOpacity>
          </View>
          <ScrollView showsVerticalScrollIndicator={false}>
            {screens.map((obj, index) => {
              if (obj.screen == "VOC" || obj.virtual) return null;

              return (
                <HeaderTab
                  key={index}
                  onPress={() => {
                    setMiscModal(false, { x: -1, y: -1 }, null);
                    const params = { label: obj.label, headerTitle: obj.headerTitle };
                    if (obj.labelSt) params.labelSt = JSON.stringify(obj.labelSt);
                    if (obj.label == "Spare Parts") params.tab = "purchase_request";
                    navigation.navigate(obj.screen, params);

                    if (obj?.screen?.toLowerCase() === "purchase") {
                      navigation.navigate(obj.screen, params);
                    }

                    console.log("SIDE MENU ----- ", params, obj);
                  }}
                  isActive={
                    navState.routeName === obj.screen ||
                    (sparesExtraScreens?.includes(navState.routeName) && obj.screen === "SparePartsScreen")
                  }
                  text={obj.label}
                  bottomText={obj.bottomText}
                  img={obj.icon}
                  icon={obj.navIcon}
                />
              );
            })}
          </ScrollView>
        </>
      </View>
    );

  return <></>;
};

export default memo(SideMenuV3);

const headerStyles = StyleSheet.create({
  sideMenu: {
    overflow: "visible",
    maxWidth: 72,
    zIndex: 2,
  },
  tab: {
    justifyContent: "center",
    alignItems: "center",
    padding: 15,
    marginBottom: 30,
  },
  logo: { marginHorizontal: "1rem" },
  tabText: {
    lineHeight: 24,
  },
});
